/** Validation message codes returned by the bank account field validation endpoint */
export const BANK_ACCOUNT_FIELD_VALIDATION_MESSAGES = {
  INVALID_FORMAT: 'INVALID_FORMAT',
  SWIFT_MISMATCH: 'SWIFT_MISMATCH',
}
